import { getToken } from '@/request/utils'
import cloneDeep from 'lodash/cloneDeep'

export const INIT_LOGIN_DATA = {
  lang: '',
  logined: window.inSDK || !!getToken(),
  gamePlayer: {
    playerId: '',
    serverId: '',
    playerName: '',
  } as GamePlayer,
  sdkConfig: {
    appLang: '',
    appId: window.appId,
    clientVersion: '',
    deviceId: '',
    platform: '',
  } as SdkConfig,
  userInfo: {
    lang: '',
    userId: '',
    sessionId: '',
    playerId: '',
    playerType: 1,
    /** 0未知 美洲1 欧洲2 东南亚3 东亚5 */
    zoneId: 0 as Zone['zoneId'],
    serverId: '',
    serverName: '',
    playerName: '',
    checked: 0,
    isBinded: false,
    isCodeBinded: false,
  } as UserInfo,
  roleList: [] as Role[],
}

export const login = cloneDeep(INIT_LOGIN_DATA)
